export const PROVIDERS_API = `/gateway/api/object-resolver/providers`;
export const RESOLVE_API = `/gateway/api/object-resolver/resolve/batch`;
export const LS_PROVIDER_KEY = 'aiMateSmartLinkProviders';
export const LS_PROVIDER_MAPPING_KEY = 'aiMateSmartLinkProviderMapping';
